import React from 'react';
import { TextV2 } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';
import { Theme } from '@mui/material/styles';

export type ItemCountLabelProps = {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
};

const ItemCountLabel = ({
  currentPage,
  totalItems,
  itemsPerPage,
}: ItemCountLabelProps): React.ReactElement => {
  const { t } = useTranslation();
  const start = (currentPage - 1) * itemsPerPage + 1;
  const end = Math.min(currentPage * itemsPerPage, totalItems);
  const label = t('ui.common.pagination.item.count.label', {
    start,
    end,
    totalItems,
  });
  return (
    <TextV2
      component="p"
      color="textPrimary"
      sx={(theme: Theme) => ({
        marginRight: theme.spacing(2),
        height: theme.spacing(4),
        lineHeight: theme.spacing(4),
      })}
    >
      {label}
    </TextV2>
  );
};

export default ItemCountLabel;
